export default {
      id: "i-pif-cart-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/sprite.svg#i-pif-cart",
      toString: function () {
        return this.url;
      }
    }